import { render, staticRenderFns } from "./CategoryBadge.vue?vue&type=template&id=2d03c15e&"
import script from "./CategoryBadge.vue?vue&type=script&lang=js&"
export * from "./CategoryBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports